import { savedPanel } from 'saved-panel-animations'
import { Modal } from 'bootstrap'
import { ddlClientContactInitialise, ddlClientInitialise } from 'slim-select-prefabs'
import { validateStyle } from 'validate-style-animations'
import { appendInputGroup, createTable } from '../General/utils'
import { Grid } from 'gridjs'

let addMailshotContact: Modal

const addMailshotContactClick = () => {
    const btnAddMailshotContact = document.querySelector(
        '.btnAddMailshotContact'
    ) as HTMLButtonElement
    if (btnAddMailshotContact !== null) {
        btnAddMailshotContact.addEventListener('click', () => {
            const client = document.querySelector('.ddlClientID') as HTMLSelectElement
            const ddlClientIDSlim = client.nextElementSibling!.firstElementChild as HTMLFormElement
            if (client.value.toString() !== '0' && client !== null) {
                // Validated
                validateStyle(ddlClientIDSlim, false)
                const hidAddMailshotContact = document.getElementById(
                    'hidAddMailshotContact'
                ) as HTMLFormElement
                const ddlLogClientContactID = document.querySelector(
                    '.ddlLogClientContactID'
                ) as HTMLSelectElement
                const mailshotID = document.querySelector('.MailshotID') as HTMLFormElement
                fetch(
                    `${hidAddMailshotContact.value.toString()}?ClientContactID=${encodeURIComponent(
                        ddlLogClientContactID.value.toString()
                    )}&MailshotID=${encodeURIComponent(mailshotID.value.toString())}`,
                    {
                        method: 'POST'
                    }
                )
                    .then((response) => response.text())
                    .then(() => {
                        addMailshotContact.hide()
                        setTimeout(() => {
                            savedPanel()
                            setTimeout(() => {
                                window.location.reload()
                            }, 2000)
                        }, 500)
                    })
            } else {
                validateStyle(ddlClientIDSlim, true)
            }
        })
    }
}
const initialise = () => {
    const element = document.getElementById('MailshotContactTable') as HTMLTableElement
    const renderedID = createTable(element) as string
    new Grid({
        columns: [
            'Name',
            'Email',
            'Client',
            'GDPR Consent',
            {
                name: '',
                sort: false
            }
        ],
        pagination: {
            limit: 500
        },
        sort: true,
        search: true,
        resizable: true,
        language: {
            search: {
                placeholder: 'Search...'
            },
            pagination: {
                previous: '<',
                next: '>',
                showing: '😃 Displaying',
                results: () => 'Records'
            }
        },
        from: element
    }).render(document.getElementById(renderedID)!)

    appendInputGroup(element.getAttribute('name')!)
    const btnAddMailshotContactModal = document.querySelector(
        '.btnAddMailshotContactModal'
    ) as HTMLButtonElement
    if (btnAddMailshotContactModal != null) {
        btnAddMailshotContactModal.addEventListener('click', () => {
            const addMailshotContactDiv = document.querySelector('.AddMailshotContact') as HTMLFormElement
            addMailshotContact = new Modal(addMailshotContactDiv, {
                backdrop: true,
                keyboard: true
            })
            ddlClientInitialise()
            ddlClientContactInitialise()
            addMailshotContactClick()
            addMailshotContact.show()
        })
    }
    const btnUpdateMailshotDetails = document.querySelector(
        '.btnUpdateMailshotDetails'
    ) as HTMLButtonElement
    if (btnUpdateMailshotDetails != null) {
        btnUpdateMailshotDetails.addEventListener('click', () => {
            const mailshotName = document.querySelector('.txtMailshotName') as HTMLInputElement
            const mailshotDescription = document.querySelector(
                '.txtMailshotDescription'
            ) as HTMLInputElement
            const mailshotType = document.querySelector('.ddlMailshotType') as HTMLSelectElement
            const mailshotID = document.querySelector('.MailshotID') as HTMLFormElement
            const hidUpdateMailshotDetails = document.getElementById(
                'hidUpdateMailshotDetails'
            ) as HTMLFormElement
            fetch(
                `${hidUpdateMailshotDetails.value.toString()}?MailshotName=${encodeURIComponent(
                    mailshotName.value.toString()
                )}&MailshotDescription=${encodeURIComponent(
                    mailshotDescription.value.toString()
                )}&MailshotType=${encodeURIComponent(
                    mailshotType.value.toString()
                )}&MailshotID=${encodeURIComponent(mailshotID.value.toString())}`,
                {
                    method: 'POST'
                }
            )
                .then((response) => response.text())
                .then(() => {
                    savedPanel()
                })
        })
    }
}

window.addEventListener('load', () => {
    initialise()
})
